import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as registerActionsCreators from '../../../../actionCreators/auth';
import * as cartCallsActionCreators from '../../../../actionCreators/cart';
import * as commonCallsActionCreators from '../../../../actionCreators/common';
import * as productCallsActionCreators from '../../../../actionCreators/product';
import Modal from '../../../../CommonComponents/BootstrapComponents/Modal/Modal';
import Tab from '../../../../CommonComponents/BootstrapComponents/Tabs/Tab';
import Tabs from '../../../../CommonComponents/BootstrapComponents/Tabs/Tabs';
import { AddToCartTikTokEvent } from '../../../../utils/tiktokPixel';
import ContactLensCarousel from '../SideBar/ContactLensCarousel';
import './ContactLenses.scss';
// import ContactLensSelectPower from './ContactLensSelectPower';
import EnterPrescription from './EnterPrescription';
import NewContactLensSelectPower from './NewContactLensSelectPower';
import PrescriptionHelp from './PrescriptionHelp';
import SavedPrescription from './SavedPrescription';
import UploadPrescription from './UploadPrescription';

class ContactLenses extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      key: 1,
      userNameError: 'hide user-name',
      BoxedValue: 'hide user-name',
      imagePreviewUrl: '',
      isChecked: true,
      toggleChecked: false,
      uploadSuccess: null,
      uploadError: null,
      rightBoxValue: 1,
      leftBoxValue: 1,
      isContactPrescValid: true,
      addToCartData: null,
      missingPowerList: [],
      offerModalBtnClicked: null,
      contactLensId: null,
      selectedSavedPrescription: null,
      contactPrescription: true,
      selectPowerType: null,
    };
    this.newCartFlowEnable = false;
    this.updatePowerErrorList = this.updatePowerErrorList.bind(this);
  }

  componentDidUpdate(prevProps) {
    const {
      isContactPrescValid,
      loginStatus,
      cartCallsAction,
      commonCallsAction,
      productData,
      userInputErr,
      user,
      inValidPres,
      isNonJitPowerValidated,
      redisCommonData,
    } = this.props;

    this.newCartFlowEnable = !!(
      redisCommonData &&
      redisCommonData?.NEW_CART_FLOW_DESKTOP &&
      JSON.parse(redisCommonData?.NEW_CART_FLOW_DESKTOP)?.enable === 'ON'
    );

    // Offer modal : on click continue handling on success screen in offer modal
    const { isContinueClickedInOfferModalSuccess, pdp_ipl, renderOfferModal } = this.props;
    const { offerModalBtnClicked } = this.state;
    if (pdp_ipl && isContinueClickedInOfferModalSuccess && offerModalBtnClicked) {
      this.open(...offerModalBtnClicked.param);
      (() => {
        this.setState({ offerModalBtnClicked: null });
      })();
      renderOfferModal(false);
    }
    // Normal Flow
    if (
      isContactPrescValid !== prevProps.isContactPrescValid &&
      isContactPrescValid !== null &&
      !inValidPres &&
      isNonJitPowerValidated
    ) {
      this.setPrescValidState(true);
      this.triggerTiktokEvent();
      cartCallsAction.addToCart(this.state.addToCartData, this.getUrlQueryPackage());
      if (window.dtm.LenskartRewamp) {
        window.dtm.LenskartRewamp.Pdp.click.addToCart(productData);
        if (this.newCartFlowEnable) {
          this.props.history.replace('/cart');
        }
      }

      commonCallsAction.toggleCart(true, 'add');

      if (this.newCartFlowEnable) {
        this.props.history.replace('/cart');
      }
      this.hideModalAndUpdateErrorStates();
    }
    const prescValidCondition =
      prevProps.isContactPrescValid !== isContactPrescValid && isContactPrescValid !== null;
    if (
      (productData.jit && prescValidCondition && inValidPres && isNonJitPowerValidated) ||
      (!productData.jit &&
        prescValidCondition &&
        ((!inValidPres && !isNonJitPowerValidated) || (inValidPres && isNonJitPowerValidated)))
    ) {
      this.setPrescValidState(false);
    }
    if (this.state.key === 3 && prevProps.loginStatus !== loginStatus && loginStatus) {
      this.props.productCallsAction.getCLSavedPrescription();
    }
    if (prevProps.userInputErr !== userInputErr && userInputErr && userInputErr.status === 401)
      commonCallsAction.setJunoSession();

    if (this.state.key === 3 && !prevProps.user && user) {
      commonCallsAction.getUserInfo();
      commonCallsAction.shortlist('', 'get', '?attributes=true');
    }
  }

  setPrescValidState = val => {
    this.setState({ isContactPrescValid: val });
  };

  setName = name => {
    this.textFirstName = name;
  };

  setDOB = dob => {
    this.textDob = dob;
  };

  setNotes = notes => {
    this.textNotes = notes;
  };

  getUrlQueryPackage = () => {
    const query = this.props.location.search.substr(1);
    const result = {};
    query.split('&').forEach(param => {
      const item = param.split('=');
      result[item[0]] = decodeURIComponent(item[1]);
    });
    return result.package;
  };

  genderValueUpdate = event => {
    const genderVal = event.target.value;
    this.setState({
      genderValue: genderVal,
    });
  };

  toggleChange = () => {
    this.setState({
      isChecked: !this.state.isChecked,
    });
  };

  hideModalAndUpdateErrorStates = () => {
    this.setState({
      showModal: false,
      userNameError: 'hide user-name',
      BoxedValue: 'hide user-name',
      toggleChecked: false,
      imagePreviewUrl: '',
      missingPowerList: [],
    });
  };

  checkboxToggle = (e, pid) => {
    const { redisCommonData } = this.props;
    const enableNewClPowerFlow = redisCommonData?.ENABLE_NEW_CL_POWER_FLOW
      ? JSON.parse(redisCommonData?.ENABLE_NEW_CL_POWER_FLOW)
      : false;
    if (
      (this.state.key === 1 && this.rightBox.boxes.value !== '0') ||
      this.leftBox.boxes.value !== '0'
    ) {
      if (enableNewClPowerFlow)
        this.setState(prevState => ({
          toggleChecked: !prevState.toggleChecked,
        }));
      else
        this.setState(
          {
            toggleChecked: true,
          },
          () => {
            this.addToCart(e, pid);
            if (this.newCartFlowEnable) {
              this.props.history.replace('/cart');
            }
          }
        );
    } else {
      this.setState({ BoxedValue: 'user-name', toggleChecked: false });
    }
  };

  addToCartFinal = (event, pid, selectPowerType, selectedSavedPrescription) => {
    if (selectPowerType === this.props.dataLocale.USE_SAVED_PRESCRIPTION) {
      if (selectedSavedPrescription) {
        this.addTocartFromSavePrescription(event, selectedSavedPrescription);
      } else {
        // show error
      }
    } else {
      this.addToCart(event, pid);
    }
  };

  addToCart = (event, pid) => {
    if (event.target !== null) {
      event.preventDefault();
    }
    const missingPowerList = [];
    let data = {};
    const right = {};
    const left = {};
    const powerData = {
      powerOptionList: [],
    };
    Object.keys(this.rightBox).forEach(key => {
      powerData.powerOptionList.push({
        type: `Right ${key.toUpperCase()}`,
        value: this.rightBox[key]?.value,
        price: 0,
      });
      right[key] = this.rightBox[key]?.value;
    });
    Object.keys(this.leftBox).forEach(key => {
      powerData.powerOptionList.push({
        type: `Left ${key.toUpperCase()}`,
        value: this.leftBox[key]?.value,
        price: 0,
      });
      left[key] = this.leftBox[key]?.value;
    });
    Object.keys(this.rightPowers).forEach(key => {
      const value =
        this.rightPowers[key].state.defaultValue.toLowerCase() === 'please select'
          ? ''
          : this.rightPowers[key].state.defaultValue;
      powerData.powerOptionList.push({
        type: `Right ${key.toUpperCase()}`,
        value,
        price: 0,
      });
      right[key] = value;
      if (Number(right.boxes) > 0 && value === '') {
        missingPowerList.push(`right-power-${key}`);
      }
    });
    Object.keys(this.leftPowers).forEach(key => {
      const value =
        this.leftPowers[key].state.defaultValue.toLowerCase() === 'please select'
          ? ''
          : this.leftPowers[key].state.defaultValue;
      powerData.powerOptionList.push({
        type: `Left ${key.toUpperCase()}`,
        value,
        price: 0,
      });
      left[key] = value;
      if (Number(left.boxes) > 0 && value === '') {
        missingPowerList.push(`left-power-${key}`);
      }
    });
    if (
      missingPowerList.length &&
      !this.state.toggleChecked &&
      this.state.key === 1 &&
      (!this.props.productData.jit || this?.props?.localeInfo?.countryCode === 'sg')
    ) {
      this.setState({ missingPowerList, BoxedValue: 'hide user-name' });
      return;
    } else if (this.state.missingPowerList.length) {
      this.setState({ missingPowerList });
    }

    let boxesValue = JSON.stringify(Number(left.boxes) + Number(right.boxes));
    if (boxesValue === 'null' && (this.state.leftBoxValue || this.state.rightBoxValue)) {
      boxesValue = JSON.stringify(
        Number(this.state.leftBoxValue) + Number(this.state.rightBoxValue)
      );
    }

    if (this.state.imagePreviewUrl) {
      data = {
        productId: pid || this.props.productId,
        quantity: boxesValue,
        prescription: {
          imageFileName: this.state.imagePreviewUrl,
          left:
            this.state.leftBoxValue > 0
              ? { boxes: this.state.leftBoxValue + '', sph: '' }
              : undefined,
          right:
            this.state.rightBoxValue > 0
              ? { boxes: this.state.rightBoxValue + '', sph: '' }
              : undefined,
          powerType: 'CONTACT_LENS',
        },
      };
    }
    if (
      (!this.state.toggleChecked || !this.props.productData.jit) &&
      this.state.key === 1 &&
      /^[a-zA-Z\s]+$/.test(this.textFirstName?.value?.trim())
    ) {
      data = {
        productId: pid || this.props.productId,
        quantity: boxesValue,
        prescription: {
          dob: this.textDob?.value === undefined ? '' : this.textDob?.value,
          gender: this.state.genderValue === undefined ? '' : this.state.genderValue,
          notes: this.textNotes?.value === undefined ? '' : this.textNotes?.value,
          userName: this.textFirstName?.value,
          powerType: 'CONTACT_LENS',
        },
      };
      if (left.boxes !== '0') {
        data.prescription.left = left;
      }
      if (right.boxes !== '0') {
        data.prescription.right = right;
      }
    } else {
      this.setState({ userNameError: 'user-name' });
    }
    if (pid) {
      data.productId = pid;
    }
    if (!this.state.toggleChecked && this.state.key === 1) {
      this.setState({ isContactPrescValid: true });
      if (
        (this.rightBox.boxes?.value !== '0' || this.leftBox.boxes?.value !== '0') &&
        /^[a-zA-Z\s]+$/.test(this.textFirstName?.value.trim())
      ) {
        if (!this.props.productData.jit)
          this.props.productCallsAction.isContactPrescValid(data, null);
        else
          this.props.productCallsAction.isContactPrescValid(powerData, pid || this.props.productId);
      }
    }
    if (
      (!this.state.toggleChecked && this.state.key === 1 && right.boxes !== '0') ||
      left.boxes !== '0'
    ) {
      this.setState({ BoxedValue: 'hide user-name' });
    } else {
      this.setState({ BoxedValue: 'user-name' });
    }
    if (this.state.key === 4 || this.state.toggleChecked) {
      // if (this.state.key === 4) {
      //     boxesValue = '2';
      //     left.boxes = '1';
      //     right.boxes = '1';
      // }
      // right.sph = 'Call Me/Email Me for Power';
      // left.sph = 'Call Me/Email Me for Power';
      data = {
        productId: pid || this.props.productId,
        quantity: boxesValue,
        prescription: {
          left:
            this.state.leftBoxValue > 0
              ? { boxes: this.state.leftBoxValue + '', sph: 'Call Me/Email Me for Power' }
              : undefined,
          right:
            this.state.rightBoxValue > 0
              ? { boxes: this.state.rightBoxValue + '', sph: 'Call Me/Email Me for Power' }
              : undefined,
          powerType: 'CONTACT_LENS',
        },
      };
    }
    this.setState({ addToCartData: data });
    if (this.state.isChecked && this.props.productData.crossSells.length)
      data.relatedProductIds = [this.props.productData.crossSells[0].id];
    if (this.state.imagePreviewUrl || this.state.toggleChecked || this.state.key === 4) {
      this.triggerTiktokEvent();
      this.props.cartCallsAction.addToCart(data, this.getUrlQueryPackage());
      if (window.dtm.LenskartRewamp) {
        if (pid) {
          let i = 0;
          while (!this.props.coloredLensData && i < 100000000) {
            i++;
          }
          const coloredLensData =
            pid && this.props.coloredLensData ? this.props.coloredLensData.result : null;
          window.dtm.LenskartRewamp.Pdp.click.addToCart(coloredLensData || this.props.productData);
          if (this.newCartFlowEnable) {
            this.props.history.replace('/cart');
          }
        } else {
          window.dtm.LenskartRewamp.Pdp.click.addToCart(this.props.productData);
          if (this.newCartFlowEnable) {
            this.props.history.replace('/cart');
          }
        }
      }

      this.props.commonCallsAction.toggleCart(true, 'add');
      if (this.newCartFlowEnable) {
        this.props.history.replace('/cart');
      }
      this.setState({
        showModal: false,
        userNameError: 'hide user-name',
        BoxedValue: 'hide user-name',
        toggleChecked: false,
        imagePreviewUrl: '',
      });
    } else if (/^[a-zA-Z\s]+$/.test(this.textFirstName?.value.trim())) {
      this.setState({ userNameError: 'hide user-name' });
    }
  };

  close = () => {
    this.setState({ showModal: false, BoxedValue: 'hide user-name', missingPowerList: [] });
  };

  handleSelect = key => {
    if (this.rightBox.boxes?.value !== '0' || this.leftBox.boxes?.value !== '0') {
      this.setState({ key }, () => {
        if (this.state.key === 3 && this.props.loginStatus) {
          this.props.productCallsAction.getCLSavedPrescription();
        }
      });
      this.setState({
        BoxedValue: 'user-name hide',
        isContactPrescValid: true,
        missingPowerList: [],
      });
    } else {
      this.setState({ BoxedValue: 'user-name', isContactPrescValid: true, missingPowerList: [] });
    }
  };

  fileUploadSuccess = (success, uploadSuccess) => {
    if (uploadSuccess.result.code === 200) {
      this.setState({ imagePreviewUrl: uploadSuccess.result.filename });
    } else if (uploadSuccess.result.error) {
      this.setState({
        uploadError: uploadSuccess.result.error,
      });
    }
  };

  modelHide = value => {
    this.setState({
      showModal: value,
    });
  };

  open = (rightBoxValue, leftBoxValue, pid, isNotClicked) => {
    const {
      productCallsAction,
      productData,
      renderOfferModal,
      isRepeatUser,
      pdp_ipl,
      isContinueClickedInOfferModalSuccess,
      redisCommonData,
    } = this.props;
    const enableNewClPowerFlow = redisCommonData?.ENABLE_NEW_CL_POWER_FLOW
      ? JSON.parse(redisCommonData?.ENABLE_NEW_CL_POWER_FLOW)
      : false;
    // const enableNewClPowerFlow = false;
    // Offer Modal Flow : If user hasPlacedOrder is false then open offer modal else normal flow.
    if (pid) {
      productCallsAction.getColoredLensData(pid);
      this.setState({
        key: 1,
        showModal: !enableNewClPowerFlow,
        isContactPrescValid: true,
        addToCartData: null,
        rightBoxValue,
        leftBoxValue,
        missingPowerList: [],
        contactLensId: pid,
      });
      productCallsAction.loadContactLens(pid, 'contact_lens');
      if (!isNotClicked) this.triggerFBEvent();
    } else if (
      pdp_ipl &&
      renderOfferModal &&
      !isRepeatUser &&
      !isContinueClickedInOfferModalSuccess
    ) {
      renderOfferModal(true);
      this.setState({
        offerModalBtnClicked: {
          name: 'open',
          param: [rightBoxValue, leftBoxValue],
        },
      });
    } else {
      // NOT a offer flow
      // this.setState({ showModal: true, isContactPrescValid: true, addToCartData: null });
      productCallsAction.loadContactLens(productData.id, 'contact_lens');
      this.setState({
        key: 1,
        showModal: !enableNewClPowerFlow,
        isContactPrescValid: true,
        addToCartData: null,
        rightBoxValue,
        leftBoxValue,
        missingPowerList: [],
        contactLensId: null,
      });
      if (!isNotClicked) this.triggerFBEvent();
    }
  };

  triggerFBEvent = () => {
    const { productData } = this.props;
    const { classification, prices } = productData;
    const lenskartPrice = prices?.filter(p => p.name === 'Lenskart Price');
    const currencyCode = prices && prices.length > 0 ? prices[0].currencyCode : '';
    window.ReactPixel.default.track('AddToCart', {
      content_type: 'product',
      content_ids: productData?.id,
      value: lenskartPrice[0]?.price,
      content_name: classification,
      currency: currencyCode,
    });
  };

  triggerTiktokEvent = () => {
    const { productData } = this.props;
    const { classification, prices } = productData;
    const lenskartPrice = prices?.filter(p => p.name === 'Lenskart Price');
    const currencyCode = prices && prices.length > 0 ? prices[0].currencyCode : '';
    AddToCartTikTokEvent({
      currency: currencyCode,
      productId: productData?.id,
      productName: classification,
      productPrice: lenskartPrice,
    });
  };

  selectedPrescription = data => {
    this.setState(
      {
        addToCartData: data,
      },
      () => {}
    );
  };

  leftBoxChange = event => {
    const { value } = event.target;
    this.setState({ leftBoxValue: value }, () => {
      if (value === '0') {
        this.updatePowerErrorList(null, 'left');
      }
    });
  };

  rightBoxChange = event => {
    const { value } = event.target;
    this.setState({ rightBoxValue: value }, () => {
      if (value === '0') {
        this.updatePowerErrorList(null, 'right');
      }
    });
  };

  handleActionForDropDown = event => {
    if (!event.target.parentNode.classList.contains('cl-dd')) {
      this.props.productCallsAction.handleClDropdownOpenList('');
    }
  };

  calculateBoxPrice = (lkprice, discount, gst, roundOffUpto) => {
    const priceWithGst = lkprice + lkprice * (gst / 100);
    let finalPriceAfterDiscount = priceWithGst - priceWithGst * (discount / 100);
    finalPriceAfterDiscount =
      roundOffUpto === 0
        ? Math.round(finalPriceAfterDiscount)
        : finalPriceAfterDiscount.toFixed(roundOffUpto);
    return `${finalPriceAfterDiscount}/BOX`;
  };

  updatePowerErrorList(fieldName, boxKey) {
    let { missingPowerList } = this.state;
    const { localeInfo } = this.props;
    const { jit } = this.props.productData;
    if ((!jit || localeInfo?.countryCode === 'sg') && missingPowerList.length) {
      if (boxKey) {
        missingPowerList = missingPowerList.filter(errpower => !errpower.includes(boxKey));
      } else if (fieldName) {
        missingPowerList.splice(missingPowerList?.indexOf(fieldName), 1);
      }
      this.setState({ missingPowerList });
    }
  }

  addToCartZeroCl = () => {
    this.triggerTiktokEvent();
    const data = {
      productId: this.props.productId,
      quantity: 1,
      prescription: {
        dob: '',
        gender: '',
        notes: '',
        userName: 'lenskart user',
        powerType: 'CONTACT_LENS',
        left: {
          boxes: '1',
          sph: '0.00',
        },
      },
    };
    this.props.cartCallsAction.addToCart(data, this.getUrlQueryPackage());

    this.props.commonCallsAction.toggleCart(true, 'add');
    if (this.newCartFlowEnable) {
      this.props.history.replace('/cart');
    }
  };

  addTocartFromSavePrescription = (event, savedData) => {
    event.preventDefault();
    window.ReactPixel.default.track('AddToCart', {
      content_type: 'product',
      content_ids: [this.props.productData.id],
      value: this.props.productData.prices[1].price.toFixed(2),
      content_name: this.props.productData.fullName,
      currency: 'INR',
    });
    let data = {};
    data = {
      productId: this.props.productData.id,
      quantity: savedData.left.boxes + savedData.right.boxes,
      prescription: {
        left: savedData.left,
        right: savedData.right,
      },
    };
    if (this.state.leftBoxValue > 0) {
      data.prescription.left.boxes = this.state.leftBoxValue + '';
    } else {
      data.prescription.left = undefined;
    }
    if (this.state.rightBoxValue > 0) {
      data.prescription.right.boxes = this.state.rightBoxValue + '';
    } else {
      data.prescription.right = undefined;
    }
    data.quantity = Number(this.state.rightBoxValue) + Number(this.state.leftBoxValue);
    this.selectedPrescription(data);
    // setState({
    //   contactPrescription: true,
    //   itemIndex: index,
    // });
    this.setState({ contactPrescription: true });

    // setShowErrorBox(index);
    if (this.state.isChecked && this.props.productData.crossSells.length)
      data.relatedProductIds = [this.props.productData.crossSells[0].id];
    if (savedData.right.sph?.indexOf('call') === -1 || savedData.left.sph?.indexOf('call') === -1) {
      this.setState({ contactPrescription: true });
      const powerData = {
        powerOptionList: [],
      };
      Object.keys(savedData.right).forEach(key => {
        powerData.powerOptionList.push({
          type: `Right ${key.toString().toUpperCase()}`,
          value: key === 'boxes' ? this.state.rightBoxValue + '' : savedData.right[key],
          price: 0,
        });
      });
      Object.keys(savedData.left).forEach(key => {
        powerData.powerOptionList.push({
          type: `Left ${key.toString().toUpperCase()}`,
          value: key === 'boxes' ? this.state.leftBoxValue + '' : savedData.left[key],
          price: 0,
        });
      });
      if (this.props.productData.jit) {
        this.props.productCallsAction.isContactPrescValid(powerData, this.props.productData.id);
      } else {
        this.props.productCallsAction.isContactPrescValid(data, null);
      }
    } else {
      this.props.cartCallsAction.addToCart(data, this.getUrlQueryPackage());
      this.props.commonCallsAction.toggleCart(true, 'add');
      this.modelHide(false);
    }
  };

  selectSavedPrescription = data => {
    this.setState({ selectedSavedPrescription: data });
  };

  setSelectPowerType = type => {
    this.setState({ selectPowerType: type });
  };

  render() {
    this.rightPowers = {};
    this.leftPowers = {};
    this.rightBox = { boxes: {} };
    this.leftBox = { boxes: {} };
    const {
      currencyMark,
      productData,
      contactLensData,
      isContactPrescValid,
      redisCommonData,
      userInputErr,
      oTPSent,
      userInputValidate,
      oTPLoginSuccess,
      username,
      loading,
      user,
      loginError,
      selectedPowerFromUrl,
      isNonJitPowerValidated,
      dataLocale,
      localeInfo,
    } = this.props;
    const currencyCode =
      productData && productData?.result
        ? productData?.result?.prices?.[0]?.currencyCode
        : dataLocale.CURRENCY_CODE;
    const currencySymbol = currencyMark[currencyCode];
    const { missingPowerList } = this.state;
    let clRedis = {};
    const disableBuyOnCall = redisCommonData?.DISABLE_BUY_CALL === 'ON';
    // delete key 'PDP_CL_BOX_CONFIG' incase we dont need to show the boxes
    if (redisCommonData.PDP_CL_BOX_CONFIG) {
      clRedis = JSON.parse(redisCommonData.PDP_CL_BOX_CONFIG);
    }
    const {
      ORDER_ON_PHONE,
      ORDER_ON_PHONE_NUMBER,
      GIVE_MISSED_CALL,
      NEED_HELP,
      BUY_NOW,
      SELECT_YOUR_LENS,
      ENTER_PRESCRIPTION,
      MAKE_PAYMENT,
      ENTER_YOUR_PRESCRIPTION,
      UPLOAD_YOUR_PRESCRIPTION,
      USE_SAVED_PRESCRIPTION,
      ADDITIONAL_ITEM,
    } = dataLocale;
    const showContactLensCarousel = redisCommonData?.SHOW_CONTACT_LENS_CAROUSEL
      ? JSON.parse(redisCommonData?.SHOW_CONTACT_LENS_CAROUSEL)?.desktop
      : false;

    const enableNewClPowerFlow = redisCommonData?.ENABLE_NEW_CL_POWER_FLOW
      ? JSON.parse(redisCommonData?.ENABLE_NEW_CL_POWER_FLOW)
      : false;
    return (
      <div className="clPrescriptionContainer">
        <div className="clearfix margin-b5" />
        {productData.crossSells.length ? (
          <div className="col-lg-12 col-md-12 col-sm-12 no-padding text-black contact-lens-wrap tickcheckbox">
            <div className="display-flex padding-b10">
              <input defaultChecked type="hidden" value="" onChange={this.toggleChange} />
              <span className="width-5">
                <img
                  alt={ADDITIONAL_ITEM}
                  src="https://static.lenskart.com/media/desktop/img/pdp/additional_item.png"
                ></img>
              </span>
              <span className="padding-l10 fs14">
                {productData.crossSells[0] !== undefined ? productData.crossSells[0].title : ''}
              </span>
            </div>
          </div>
        ) : (
          ''
        )}
        <div className="clearfix margin-b5" />
        {showContactLensCarousel && (
          <ContactLensCarousel data={productData} onClick={pid => this.open(1, 1, pid)} />
        )}
        {!disableBuyOnCall && (
          <div className="call-description margin-b20 padding-t10 padding-b10">
            <div className="text-center fs14 fw600 missedcall text-uppercase">{ORDER_ON_PHONE}</div>
            <div className="text-center miss-call-number text-uppercase">
              {GIVE_MISSED_CALL} : {ORDER_ON_PHONE_NUMBER}
            </div>
          </div>
        )}
        {/* <div onClick={ev => this.handleActionForDropDown(ev)}>
          {enableNewClPowerFlow && productData && !productData?.isPlano && (
            // !this.props.productData.jit &&
            <ContactLensSelectPower
              BoxedValue={this.state.BoxedValue}
              addToCart={this.addToCart}
              checkboxToggle={this.checkboxToggle}
              clOpenList={this.props.clOpenList}
              contactLensData={contactLensData}
              contactLensId={this.state.contactLensId}
              dataLocale={dataLocale}
              errPowerList={missingPowerList}
              genderValueUpdate={this.genderValueUpdate}
              isContactPrescValid={this.state.isContactPrescValid}
              isContactPrescription={isContactPrescValid}
              isJitProduct={productData.jit}
              isNonJitPowerValidated={isNonJitPowerValidated}
              leftBox={this.leftBox}
              leftBoxChange={this.leftBoxChange}
              leftBoxValue={this.state.leftBoxValue}
              leftPowers={this.leftPowers}
              loadingContactPackage={this.props.loadingContactPackage}
              localeInfo={localeInfo}
              productCallsAction={this.props.productCallsAction}
              productId={this.props.productId}
              redisCommonData={redisCommonData}
              rightBox={this.rightBox}
              rightBoxChange={this.rightBoxChange}
              rightBoxValue={this.state.rightBoxValue}
              rightPowers={this.rightPowers}
              selectedPowerFromUrl={selectedPowerFromUrl}
              setDOB={this.setDOB}
              setName={this.setName}
              setNotes={this.setNotes}
              stateKey={this.state.key}
              toggleChecked={this.state.toggleChecked}
              triggerFn={() => this.open(1, 1)}
              updatePowerErrorList={this.updatePowerErrorList}
              userNameError={this.state.userNameError}
            />
          )}
        </div> */}
        <div onClick={ev => this.handleActionForDropDown(ev)}>
          {enableNewClPowerFlow && productData && !productData?.isPlano && (
            // !this.props.productData.jit &&
            <NewContactLensSelectPower
              BoxedValue={this.state.BoxedValue}
              addToCart={this.addToCart}
              checkboxToggle={this.checkboxToggle}
              clOpenList={this.props.clOpenList}
              contactLensData={contactLensData}
              contactLensId={this.state.contactLensId}
              contactPrescription={this.state.contactPrescription}
              dataLocale={dataLocale}
              enableNewClPowerFlow={enableNewClPowerFlow}
              errPowerList={missingPowerList}
              genderValueUpdate={this.genderValueUpdate}
              isContactPrescValid={this.state.isContactPrescValid}
              isContactPrescription={isContactPrescValid}
              isJitProduct={productData.jit && localeInfo?.countryCode !== 'sg'}
              isNonJitPowerValidated={isNonJitPowerValidated}
              leftBox={this.leftBox}
              leftBoxChange={this.leftBoxChange}
              leftBoxValue={this.state.leftBoxValue}
              leftPowers={this.leftPowers}
              loadingContactPackage={this.props.loadingContactPackage}
              localeInfo={localeInfo}
              loginStatus={this.props.loginStatus}
              productCallsAction={this.props.productCallsAction}
              productData={productData}
              productId={this.props.productId}
              redisCommonData={redisCommonData}
              registerCallsActions={this.props.registerCallsActions}
              rightBox={this.rightBox}
              rightBoxChange={this.rightBoxChange}
              rightBoxValue={this.state.rightBoxValue}
              rightPowers={this.rightPowers}
              selectSavedPrescription={this.selectSavedPrescription}
              selectedPowerFromUrl={selectedPowerFromUrl}
              selectedSavedPrescription={this.state.selectedSavedPrescription}
              setDOB={this.setDOB}
              setName={this.setName}
              setNotes={this.setNotes}
              setSelectPowerType={this.setSelectPowerType}
              stateKey={this.state.key}
              toggleChecked={this.state.toggleChecked}
              triggerFn={() => this.open(1, 1, undefined, true)}
              updatePowerErrorList={this.updatePowerErrorList}
            />
          )}
        </div>
        {/* {<div className="missedcall fs12 margin-b10"><div className="miss-call-cont">ORDER ON PHONE</div> (GIVE MISSED CALL: <span className="miss-call-number">+918470007367</span>)</div>} */}
        <div className="contact-lens-wrap btn-add-to-cart">
          {Object.keys(clRedis).length ? (
            clRedis.btns.map((item, index) => {
              return (
                <button
                  key={index + 'pdp_cl_box_config'}
                  className="btn padding-t10 padding-b10 btn-warning btn-primary no-radius margin-b10"
                  style={{
                    backgroundColor: item.btnBgColor,
                    width: item.btnWidth,
                    float: item.position,
                  }}
                  onClick={() => this.open(item.rightEyeBoxCount, item.leftEyeBoxCount)}
                >
                  {item.txt}
                  <div>
                    At {currencySymbol}
                    {this.calculateBoxPrice(
                      productData.prices[1].price,
                      item.discount,
                      clRedis.gst,
                      clRedis.roundOffUptoXdecimal
                    )}
                  </div>
                </button>
              );
            })
          ) : (
            <>
              {enableNewClPowerFlow ? (
                (contactLensData?.powerTypeList?.length || productData?.isPlano) && (
                  <button
                    className="btn full-width padding-t10 padding-b10 btn-topaz no-radius buy-now-btn text-uppercase"
                    onClick={ev => {
                      if (productData?.isPlano) this.addToCartZeroCl();
                      else
                        this.addToCartFinal(
                          ev,
                          this.state.contactLensId,
                          this.state.selectPowerType,
                          this.state.selectedSavedPrescription
                        );
                      window.ReactPixel.default.track('AddToCart', {
                        content_type: 'product',
                        content_ids: [this.props.productData.id],
                        value: this.props.productData.prices[1].price.toFixed(2),
                        content_name: this.props.productData.fullName,
                        currency: 'INR',
                      });
                    }}
                  >
                    {BUY_NOW}
                  </button>
                )
              ) : (
                <button
                  className="btn full-width padding-t10 padding-b10 btn-topaz no-radius buy-now-btn text-uppercase"
                  onClick={() => {
                    if (productData?.isPlano) {
                      this.addToCartZeroCl();
                      window.ReactPixel.default.track('AddToCart', {
                        content_type: 'product',
                        content_ids: [this.props.productData.id],
                        value: this.props.productData.prices[1].price.toFixed(2),
                        content_name: this.props.productData.fullName,
                        currency: 'INR',
                      });
                    } else this.open(1, 1);
                  }}
                >
                  {BUY_NOW}
                </button>
              )}
            </>
          )}
        </div>
        {/* {enableNewClPowerFlow &&
          productData &&
          !productData?.isPlano &&
          contactLensData?.powerTypeList?.length && (
            <div className="padding-t30">
              <div className="cl-quicklinks-text">
                <p>{CL_POWER_CAN_BE_DIFF}</p>
              </div>
              <div className="cl-quicklinks-links">
                <a
                  href={`//${domainUrl}/understand-your-prescription.html`}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  {HOW_TO_READ_YOUR_PRESCRIPTION}
                </a>
                <a
                  href={`//${domainUrl}/convert-your-eyeglasses-power.html`}
                  rel="noopener noreferrer"
                  target="_blank"
                >
                  {CONVERT_EYEGLASSES_POWER}
                </a>
              </div>
            </div>
          )} */}
        {!enableNewClPowerFlow && this.state.showModal && (
          <Modal
            show
            backdropClassName="cl-modal-backdrop"
            bsSize="large"
            dialogClassName="lightbox-packages contact-popup"
            onHide={() => this.close()}
          >
            <Modal.Header closeButton>
              <Modal.Title>
                <div className="contact-lens-tabs">
                  <ul className="nav nav-tabs">
                    <li>
                      <a>
                        <div className="step-one">
                          <i className="icon-bc-back"></i>
                          <i className="icon-bc-forward"></i>
                          <div className="checkout-step-count">
                            <span className="step-count">1</span>
                            <span className="text-uppercase">{SELECT_YOUR_LENS}</span>
                          </div>
                        </div>
                      </a>
                    </li>
                    <li className="active">
                      <a>
                        <div className="step-two">
                          <i className="icon-bc-back"></i>
                          <i className="icon-bc-forward"></i>
                          <div className="checkout-step-count">
                            <span className="step-count">2</span>
                            <span className="text-uppercase">{ENTER_PRESCRIPTION}</span>
                          </div>
                        </div>
                      </a>
                    </li>
                    <li>
                      <a>
                        <div className="step-three">
                          <i className="icon-bc-back"></i>
                          <i className="icon-bc-forward"></i>
                          <div className="checkout-step-count">
                            <span className="step-count">3</span>
                            <span className="text-uppercase">{MAKE_PAYMENT}</span>
                          </div>
                        </div>
                      </a>
                    </li>
                  </ul>
                </div>
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div
                className="col-lg-12 col-md-12 col-sm-12 no-padding"
                style={{ minHeight: '488px', backgroundColor: '#fff', float: 'none' }}
                onClick={ev => this.handleActionForDropDown(ev)}
              >
                <Tabs
                  activeKey={this.state.key}
                  animation={false}
                  className="contact-option"
                  id="controlled-tab-example"
                  onSelect={this.handleSelect.bind(this)}
                >
                  <Tab eventKey={1} title={ENTER_YOUR_PRESCRIPTION}>
                    {this.state.key === 1 && (
                      <EnterPrescription
                        BoxedValue={this.state.BoxedValue}
                        addToCart={this.addToCart}
                        checkboxToggle={this.checkboxToggle}
                        clOpenList={this.props.clOpenList}
                        contactLensData={contactLensData}
                        contactLensId={this.state.contactLensId}
                        dataLocale={dataLocale}
                        errPowerList={missingPowerList}
                        genderValueUpdate={this.genderValueUpdate}
                        isContactPrescValid={this.state.isContactPrescValid}
                        isContactPrescription={isContactPrescValid}
                        isJitProduct={productData.jit}
                        isNonJitPowerValidated={isNonJitPowerValidated}
                        leftBox={this.leftBox}
                        leftBoxChange={this.leftBoxChange}
                        leftBoxValue={this.state.leftBoxValue}
                        leftPowers={this.leftPowers}
                        loadingContactPackage={this.props.loadingContactPackage}
                        localeInfo={localeInfo}
                        productCallsAction={this.props.productCallsAction}
                        productId={this.props.productId}
                        rightBox={this.rightBox}
                        rightBoxChange={this.rightBoxChange}
                        rightBoxValue={this.state.rightBoxValue}
                        rightPowers={this.rightPowers}
                        selectedPowerFromUrl={selectedPowerFromUrl}
                        setDOB={this.setDOB}
                        setName={this.setName}
                        setNotes={this.setNotes}
                        stateKey={this.state.key}
                        toggleChecked={this.state.toggleChecked}
                        updatePowerErrorList={this.updatePowerErrorList}
                        userNameError={this.state.userNameError}
                      />
                    )}
                  </Tab>
                  <Tab eventKey={2} title={UPLOAD_YOUR_PRESCRIPTION}>
                    <UploadPrescription
                      addToCart={this.addToCart}
                      dataLocale={dataLocale}
                      fileUploadSuccess={this.fileUploadSuccess}
                      imagePreviewUrl={this.state.imagePreviewUrl}
                      uploadError={this.state.uploadError}
                      uploadSuccess={this.state.uploadSuccess}
                    />
                  </Tab>
                  <Tab eventKey={3} title={USE_SAVED_PRESCRIPTION}>
                    {this.state.key === 3 && (
                      <SavedPrescription
                        commonCallsAction={this.props.commonCallsAction}
                        dataLocale={dataLocale}
                        isChecked={this.state.isChecked}
                        isContactPrescValid={this.state.isContactPrescValid}
                        isContactPrescription={isContactPrescValid}
                        isJitProduct={productData.jit}
                        isNonJitPowerValidated={isNonJitPowerValidated}
                        leftBoxesQty={this.state.leftBoxValue}
                        loading={loading}
                        loginError={loginError}
                        loginStatus={this.props.loginStatus}
                        modelHide={this.modalHide}
                        oTPLoginSuccess={oTPLoginSuccess}
                        oTPSent={oTPSent}
                        redisCommonData={redisCommonData}
                        registerCallsActions={this.props.registerCallsActions}
                        rightBoxesQty={this.state.rightBoxValue}
                        selectedPrescription={this.selectedPrescription}
                        sidebarContent={productData}
                        user={user}
                        userInputErr={userInputErr}
                        userInputValidate={userInputValidate}
                        username={username}
                      />
                    )}
                  </Tab>
                  <Tab eventKey={4} title={NEED_HELP}>
                    <PrescriptionHelp
                      addToCart={this.addToCart}
                      dataLocale={dataLocale}
                      productId={this.props.productId}
                    />
                  </Tab>
                </Tabs>
              </div>
            </Modal.Body>
          </Modal>
        )}
      </div>
    );
  }
}

const mapStateToProps = state => ({
  loginStatus: state.common.login,
  location: state.router.location,
  clOpenList: state.product.clOpenList,
  contactLensData: state.product.contactLensData,
  loadingContactPackage: state.product.loadingContactPackage,
  isContactPrescValid: state.product.isContactPrescValid,
  inValidPres: state.product.inValidPres,
  coloredLensData: state.product.coloredLensData,
  redisCommonData: state.common.redisCommonData,
  userInputErr: state.auth.userInputErr,
  oTPSent: state.auth.oTPSent,
  userInputValidate: state.auth.userInputValidate,
  oTPLoginSuccess: state.auth.oTPLoginSuccess,
  username: state.auth.username,
  loading: state.auth.loading,
  user: state.auth.user,
  loginError: state.auth.loginError,
  isNonJitPowerValidated: state.product.isNonJitPowerValid,
  dataLocale: state.locale,
  currencyMark: state.common.currencyMark,
  localeInfo: state.common.localeInfo,
});

function mapDispatchToProps(dispatch) {
  return {
    productCallsAction: bindActionCreators(productCallsActionCreators, dispatch),
    registerCallsActions: bindActionCreators(registerActionsCreators, dispatch),
    cartCallsAction: bindActionCreators(cartCallsActionCreators, dispatch),
    commonCallsAction: bindActionCreators(commonCallsActionCreators, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ContactLenses);
